<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>{{ $t('addNew') }} {{ $t('api.tag.tag') }}</h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <ApisTagsForm
                            v-show="isLoaded"
                            @loaded="isLoaded = true"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApisTagsForm from '@/components/apis/tags/ApisTagsForm';

export default {
    components: {
        ApisTagsForm,
    },
    data() {
        return {
            isLoaded: false,
        };
    },
    computed: {
        headTitle() {
            return `${this.$t('addNew')} ${this.$t('api.account.account')}`;
        },
    },
};
</script>
